import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=d89f1090&scoped=true&lang=pug"
import script from "./table-header.vue?vue&type=script&lang=js"
export * from "./table-header.vue?vue&type=script&lang=js"
import style0 from "./table-header.vue?vue&type=style&index=0&id=d89f1090&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89f1090",
  null
  
)

export default component.exports